import React from "react";

export const revistaVidaTitle = (
  <div>
    La Revista <i>Vida</i>
  </div>
);

export const revistaVidaContent = (
  <div>
    <p className="content justified">
      Entre 1942 y 1955 este autor fue el encargado de la sección infantil de la revista <em>Vida</em>, de la Compañía
      Colombiana de Seguros.
    </p>
    <p className="content justified">
      En esta revista mensual, Don Os publicó por primera vez muchos de los que fueron sus cuentos más destacados y
      textos de no ficción para niños.
    </p>
    <p className="content justified">
      Muchos de sus cuentos se encuentran publicados en antologías como <i>El país de Lilac</i> (1938),{" "}
      <i>Otra vez en Lilac</i> (1942), <i>Cuentos tricolores</i> (1967), <i>Cambam Bali</i> (1973) y{" "}
      <i>Retorno a Lilac</i>
      (1987).
    </p>
  </div>
);
